<div class="modal-content">
  <div class="modal-header">
    @if (envType == appType.sdex) {
      <h4 class="modal-title" id="modal-basic-title">
        {{ (viewDetails?.file?.customFileName || selectedFile?.customFileName)
          ? (viewDetails?.file?.customFileName || selectedFile?.customFileName)
          : (viewDetails?.file?.name || selectedFile?.name) }}
      </h4>
    }
    @if (envType == appType.dams) {
      <h4 class="modal-title" id="modal-basic-title">
        {{ (viewDetails?.file?.documentNumber || selectedFile?.documentNumber)
          ? (viewDetails?.file?.documentNumber || selectedFile?.documentNumber)
          : (viewDetails?.file?.name || selectedFile?.name) }}
      </h4>
    }
    <div class="d-flex justify-content-start gap-2 align-items-center">
      @if (isSearch && !viewEsign) {
        <app-input-filed [autocomplete]="'off'" [control]="searchControl" [value]="searchControl.value" placeholder="Search"></app-input-filed>
        @if (searchControl.value) {
          <small (click)="clearSearch()" class="close-icon btn-close" aria-label="close"></small>
        }
        <button class="search-btn" (click)="onSearch($event)">Search</button>
      }
      <app-common-icon [iconSrc]="'../../../assets/Images/document-preview/Download.svg'" [toolTip]="'Download'"
        [className]="'document-info--options__Icons pointer-cursor'" [placement]="'left'"
        (clickEvent)="downloadFile()">
      </app-common-icon>
      <div (click)="modal.dismiss('Cross click')" class="close cursor-pointer">
        <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon">
      </div>
    </div>
  </div>

  <div class="modal-body" [ngClass]="{'body-div': isSearch === true}">
    <div class="search-controls-div">
      <div class="search-controls">
        @if (searchState === 3 && searchText) {
          <span>Searching for {{ searchText }}...</span>
        }
        @if (searchState === 1 && searchText) {
          <span>No matches found</span>
        }
        @if (searchReady && matchCount > 0) {
          <span class="match-count">Match {{ currentMatchIndex }} of {{ matchCount }}</span>
          <button (click)="goToPreviousMatch()" [disabled]="matchCount === 0">⬆ Prev</button>
          <button (click)="goToNextMatch()" [disabled]="matchCount === 0">⬇ Next</button>
        }
      </div>
    </div>

    <div #fileContainer>
      @if (noPreview) {
        <div class="no-preview-div">
          <span>Preview cannot be loaded. Please download to view.</span>
        </div>
      }
    </div>

    @if (pdfSrc && fileExtension === 'pdf') {
      <div class="pdf-page-load">
        <pdf-viewer class="pdf-container" [src]="pdfSrc" [zoom]="0.90" [show-all]="true" [render-text]="true"
          [render-text-mode]="1" [original-size]="false" [fit-to-page]="false" [zoom-scale]="'page-width'"
          [stick-to-page]="false" [autoresize]="true" [show-borders]="false"
          style="display: block; height: 100vh; z-index: 9999;">
        </pdf-viewer>
      </div>
    }
    @if (pdfSrc && (fileExtension === 'jpeg' || fileExtension === 'png')) {
      <div class="img-container">
        <img class="img-w" [src]="pdfSrc" alt="img"/>
      </div>
    }
    @if (pdfSrc && fileExtension === 'txt') {
      <div class="img-container">
        <iframe [src]="docUrl(pdfSrc)" title="document" height="100%" width="100%"></iframe>
      </div>
    }
    @if (pdfSrc && !fileTypes.includes(fileExtension)) {
      <div class="img-container">
        <img class="img-w"
          [src]="selectedFile?.thumbnailUrl ? selectedFile?.thumbnailUrl : '../../../assets/Images/document-preview/Files.svg'"
          alt="defaultimg"/>
      </div>
    }
  </div>
</div>